// export const version = '1.0.0';
// export const port = 8080;
// export const cdnUrl = 'https://media8.smartstudy.com';
// export const loginUrl = 'https://www.smartstudy.com/signin?no_meiqia=1&smartRedirect=';
// export const zhikeUrl = 'https://www.smartstudy.com';
// export const smartUrl = 'https://sp.smartstudy.com';
// export const toeflUrl = '//ti-toefl.smartstudy.com';
// export const ieltsUrl = '//ti-ielts.smartstudy.com';
// export const apiUrl = 'https://api.smartstudy.com/tiku';
// export const getTelUrl = 'https://api.smartstudy.com/tel_query/api/tel_query';

// export const examIdForPracticeId = [
//   // 30分钟，精华版入学测评
//   {
//     1: 1000002,
//     2: 1000003,
//   },
//   // 完整版入学测评
//   {
//     1: 1000062,
//     2: 1000063,
//     56: 1000171,
//   },
//   // 智适应入学测评
//   {
//     2: 1000173,
//   },
// ];


export const version = '1.0.0';
export const port = 8080;
export const cdnUrl = 'https://media8.smartstudy.com';
export const loginUrl = 'https://www.smartstudy.com/signin?no_meiqia=1&smartRedirect=';
export const zhikeUrl = 'https://www.smartstudy.com';
export const smartUrl = 'https://sp.smartstudy.com';
export const toeflUrl = '//ti-toefl.smartstudy.com';
export const ieltsUrl = '//ti-ielts.smartstudy.com';
export const apiUrl = 'https://api.smartstudy.com/tiku';
export const getTelUrl = 'https://api.smartstudy.com/tel_query/api/tel_query';

export const examIdForPracticeId = [
  // 30分钟，精华版入学测评
  {
    1: 1000002,
    2: 1000003,
  },
  // 完整版入学测评
  {
    1: 1000062,
    2: 1000063,
    56: 1000171,
  },
  // 智适应入学测评
  {
    2: 1000173,
  },
];




// WEBPACK FOOTER //
// ./src/common/config.js